/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './rejectJoinRequest.defs.js'
export { main as default } from './rejectJoinRequest.defs.js'
